export const SAVE_VECTOR_SCENE = 'SAVE_VECTOR_SCENE';
export const DELETE_VECTOR_SCENE = 'DELETE_VECTOR_SCENE';
